module.exports = __webpack_public_path__ + "static/media/document-resume.a167edbd.pdf";